const parseCssToJss = (cssContent) => {
    const styles = {};
    const parsedCss = cssContent.split('}');
    parsedCss.forEach(rule => {
        const [selector, properties] = rule.split('{');
        if (selector && properties) {
            const jssRule = {};
            properties.split(';').forEach(property => {
                const [key, value] = property.split(':');
                if (key && value) {
                    jssRule[key.trim()] = value.trim();
                }
            });
            // Add '&' before the class identifier in the selector
            const formattedSelector = `& ${selector.trim()}`;
            styles[formattedSelector] = jssRule;
        }
    });
    return styles;
};
export default parseCssToJss;
//# sourceMappingURL=parseCssToJss.js.map